import React, { useState } from "react";
import { action, API, controller } from "api";
import { lsUpdate, RmvEmptyProp, ToFormData } from "hooks";
import { Button, Input } from "controls";

const OpenReg = ({
  values,
  errors,
  setErrors,
  setShowForm,
  handleInpChg,
  onSuccess,
  resetFormControls,
}) => {
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let temp = {};
    temp.cashInDrawer =
      values.cashInDrawer !== "" ? "" : "This field is required.";
    temp.registerId = values.registerId !== "" ? "" : "Please select register.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleOpen = () => {
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        if (res && res.status === 200) {
          lsUpdate("activeReg", { ...res?.result });
          onSuccess && onSuccess(res.result);
          resetFormControls();
        } else console.error("Register Opening Error: ", res);
        setLoading(false);
        setShowForm && setShowForm(false);
      };

      API(controller.SellReg + action.Post).post(
        ToFormData(
          RmvEmptyProp({ ...values, openingTime: new Date().toISOString() })
        ),
        onComplete
      );
    }
  };

  return (
    <>
      <div className="grid gap-3">
        <Input
          label="Cash In Drawer"
          name="cashInDrawer"
          value={values.cashInDrawer}
          error={errors.cashInDrawer}
          type="number"
          required={true}
          onChange={handleInpChg}
        />

        <Input
          label="Note"
          placeholder="Write here register opening notes..."
          name="openingNotes"
          value={values.openingNotes}
          multiline
          rows={3}
          inputProps={{ maxLength: 300 }}
          onChange={handleInpChg}
        />

        <Button size="large" loading={loading} onClick={handleOpen}>
          Open
        </Button>
      </div>
    </>
  );
};

export default OpenReg;
